import { translate } from 'store/modules/base/i18n/functions';
import AbstractButton from './AbstractButton';
import { connect } from 'store/modules/base/redux/functions';
import { getLocalParticipant } from 'store/modules/base/participants/functions';
import {
  AUDIO_MUTE_BUTTON_ENABLED,
  getFeatureFlag
} from 'store/modules/base/flags';
import { isLocalTrackMuted } from 'store/modules/base/tracks/functions';
import { MEDIA_TYPE } from 'store/modules/base/media/constants';
import { sendMessage } from 'store/modules/chat/actions';
import { JoinAudio } from 'assets/images';

/**
 * Component that renders a toolbar button for toggling audio mute.
 *
 * @augments AbstractAudioMuteButton
 */
class JoinRemoteAudio extends AbstractButton {
  label = 'toolbar.joinTheirAudio';
  toggledLabel = 'toolbar.joinTheirAudio';
  type = 'green';
  icon = JoinAudio;

  // tooltip = 'toolbar.joinTheirAudio';

  /**
   * Initializes a new {@code AudioMuteButton} instance.
   *
   * @param {Props} props - The read-only React {@code Component} props with
   * which the new instance is to be initialized.
   */
  constructor(props) {
    super(props);
  }

  _isToggled() {
    return true;
  }

  /**
   * Changes the muted state.
   *
   * @param {boolean} audioMuted - Whether audio should be muted or not.
   * @protected
   * @returns {void}
   */
  _handleClick() {
    const id = this.props.participantId;
    const message = {
      EventType: 20,
      Message: 'Join Audio',
      FromParticipantID: this.props.localParticipant.id,
      ToParticipantID: [id]
    };

    this.props.dispatch(sendMessage(JSON.stringify(message)));
  }

  /**
   * Return a boolean value indicating if this button is disabled or not.
   *
   * @returns {boolean}
   */
  _isDisabled() {
    return this.props._disabled;
  }
}

/**
 * Maps (parts of) the redux state to the associated props for the
 * {@code AudioMuteButton} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {{
 *     _audioMuted: boolean,
 *     _disabled: boolean
 * }}
 */
function _mapStateToProps(state) {
  const _audioMuted = isLocalTrackMuted(
    state['features/base/tracks'],
    MEDIA_TYPE.AUDIO
  );
  const _conference = state['features/base/conference'].conference;
  const enabledFlag = getFeatureFlag(state, AUDIO_MUTE_BUTTON_ENABLED, true);
  const { participantId } = state['features/large-video'];

  return {
    _audioMuted,
    _isVideoOnly: state['features/settings'].videoOnly,
    _conference,
    participantId,
    visible: enabledFlag,
    localParticipant: getLocalParticipant(state)
  };
}

export default translate(connect(_mapStateToProps)(JoinRemoteAudio));
